import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 31.039 30.823',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M5.833,68.375H20.416v8.75H5.833ZM24.062,72.75a2.187,2.187,0,0,0,2.187,2.187v4.375A2.187,2.187,0,0,1,24.062,81.5H2.187A2.187,2.187,0,0,1,0,79.312V74.937A2.187,2.187,0,0,0,2.187,72.75,2.187,2.187,0,0,0,0,70.562V66.187A2.187,2.187,0,0,1,2.187,64H24.062a2.187,2.187,0,0,1,2.187,2.187v4.375A2.187,2.187,0,0,0,24.062,72.75ZM21.875,68.01a1.094,1.094,0,0,0-1.094-1.094H5.469A1.094,1.094,0,0,0,4.375,68.01v9.479a1.094,1.094,0,0,0,1.094,1.094H20.781a1.094,1.094,0,0,0,1.094-1.094Z"
          transform="matrix(0.719, 0.695, -0.695, 0.719, 56.614, -46.038)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
